import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../theme'

const deviceWidth = Dimensions.get('window').width

const styles = StyleSheet.create({
    container: {
        width: '100%',
        // El aspectRatio será provisto dinámicamente por el componente
        position: 'relative',
    },
    video: {
        width: '100%',
        // El aspectRatio será provisto dinámicamente por el componente
        backgroundColor: 'black',
        zIndex: 2,
    },
    buttons: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    containerPodcast: {
        width: '100%',
        // El aspectRatio será provisto dinámicamente por el componente
        position: 'relative',
    },
    videoPodcast: {
        width: '100%',
        // El aspectRatio será provisto dinámicamente por el componente
        backgroundColor: 'black',
        opacity: 1,
        zIndex: 2,
    },
    backgroundImagePodcast: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        resizeMode: 'cover', // Ajusta el modo de la imagen si es necesario
        zIndex: 1,
    },
    backgroundImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        resizeMode: 'cover',
    },
    titlePodcast: {
        fontSize: 18,
        fontWeight: 'bold',
        color: 'white',
        textAlign: 'left',
        marginLeft: 4,
    },
})

export default styles
